import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ALL_TEMPLATES = 'all templates'
export const TEMPLATES_NOT_FOUND = 'templates not found'
export const APPLY = 'apply'
export const CANCEL = 'cancel'
export const CLOSE = 'close'
export const SURVEY_SAVED = 'survey saved with success'
export const TEMPLATE_ADDED = 'template added'

export default {
  [PORTUGUESE]: {
    [ALL_TEMPLATES]: 'Todos os Modelos',
    [TEMPLATES_NOT_FOUND]: 'Desculpe, temos 0 resultados de pesquisa para',
    [APPLY]: 'Aplicar',
    [CANCEL]: 'Cancelar',
    [CLOSE]: 'Fechar',
    [SURVEY_SAVED]: 'Pesquisa salva com sucesso',
    [TEMPLATE_ADDED]: 'Modelo adicionado com sucesso.',
  },

  [ENGLISH]: {
    [ALL_TEMPLATES]: 'All Templates',
    [TEMPLATES_NOT_FOUND]: 'Sorry we have 0 search results for',
    [APPLY]: 'Apply',
    [CANCEL]: 'Cancel',
    [CLOSE]: 'Close',
    [SURVEY_SAVED]: 'Survey saved with success',
    [TEMPLATE_ADDED]: 'Template successfully added.',
  },

  [SPANISH]: {
    [ALL_TEMPLATES]: 'Todas los Modelos',
    [TEMPLATES_NOT_FOUND]: 'Lo sentimos, tenemos 0 resultados de búsqueda para',
    [APPLY]: 'Aplicar',
    [CANCEL]: 'Cancelar',
    [CLOSE]: 'Cerrar',
    [SURVEY_SAVED]: 'Encuesta guardada con éxito',
    [TEMPLATE_ADDED]: 'Modelo añadida con éxito.',
  },
}
